import { JsonObject, JsonProperty } from "ta-json";

import Guard from "../guard";
import { OAuthGrantBase } from "./oauth-grant-base";
import { OAuthGrantType } from "./oauth-grant-type";

@JsonObject()
export default class OAuthRefreshTokenGrant extends OAuthGrantBase {
    @JsonProperty("grant_type")
    type: OAuthGrantType = OAuthGrantType.RefreshToken;

    @JsonProperty("refresh_token")
    refreshToken: string;

    constructor(clientId: string, clientSecret: string, refreshToken: string) {
        super(clientId, clientSecret);

        Guard.notNullOrUndefined(refreshToken);
        this.refreshToken = refreshToken;
    }
}

export { OAuthRefreshTokenGrant };
